<div class="spinner" *ngIf="!isEnabled">
    <div class="bounce1"></div>
    <div class="bounce2"></div>
    <div class="bounce3"></div>
</div>
<div class="stikytop"></div>
<div class="listingParallax" *ngIf="isEnabled">
    <div class="container" style="text-align: center;">
        <div class="row" style="height: 100px;"></div>
        <h1 class="mt-5" style="color: #7ACCF6;">PROPERTY LISTINGS</h1>
    </div>
</div>
<div class="container propotion mt-5 mb-5" *ngIf="isEnabled">
    <!-- <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-4 p-2" *ngFor="let item of propertyListData">
            
            <div class="card d-block w-100">

                <img class="card-img-top " src={{server_url}}{{item.property_listing_image_url}} alt="Card image cap"
                    (click)="viewPropDetails(item.id)">
                <div class="card-body">
                    <div id="module" >
                        <h3 class="elipcont" data-toggle="tooltip" data-placement="left"  title="{{item.property_title}}">{{item.property_title}}</h3>
                        <h6 class="elipsubtit" data-toggle="tooltip" data-placement="left"  title="{{item.location}}">{{item.location}}</h6>
                       
                        <h5 class="elipcont" style="color: #891b1d;"  *ngIf="item?.property_price_usd != 0">{{item.property_price}}</h5>
                        <h5 style="visibility : 'hidden'" *ngIf="item?.property_price_usd == 0">not visible</h5>
                        <p *ngIf="propData?.property_status">{{item?.property_status}}</p>
                       
                    </div>
                   
                    <div class="container" style="text-align: center;">
                        <button type="submit" (click)="viewPropDetails(item.id)"
                            class="btn btn-default float-center pr-5 pl-5 mt-3 viewPropBtn propbtnsize">View
                            Property</button>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
    <div class="row">
        <!-- <div class="col-lg-4 col-md-4 col-sm-4 p-2" > -->
        <div class="card-group col-lg-4 col-md-4 col-sm-4 p-2" *ngFor="let item of propertyListData">
            <div class="card">
                <img class="card-img-top d-block w-100" src={{server_url}}{{item.property_listing_image_url}}
                    alt="Card image cap" (click)="viewPropDetails(item.id)">
                <div class="card-body" style="cursor: pointer;">
                    <div id="module">
                        <h5 class="card-title elipcont " data-toggle="tooltip" data-placement="left"
                            title="{{item.property_title}}" style="color: #414141; font-weight: 600;">
                            {{item.property_title}}</h5>
                        <p class="card-text elipsubtit" data-toggle="tooltip" data-placement="left"
                            title="{{item.location}}" style="color: #414141; font-weight: 500;">
                            {{item.location}}</p>
                        <h5 class="card-text elipcont" style="line-height: 1.5;" *ngIf="item?.property_price_usd != 0">
                            <span *ngIf="item?.price_range">{{item?.price_range}}</span> <b> {{item.property_price}}</b></h5>
                        <p class="card-text" style="visibility : 'hidden'" *ngIf="item?.property_price_usd == 0">not
                            visible</p>
                        <p class="card-text" *ngIf="propData?.property_status">{{item?.property_status}}</p>
                    </div>
                </div>
                <div class="card-footer " style="text-align: center;  background-color: white; border: none;">
                    <button type="submit" (click)="viewPropDetails(item.id)"
                        class="btn btn-default float-center pr-5 pl-5 viewPropBtn propbtnsize">View
                        Property</button>
                </div>
            </div>
            <!-- </div> -->
        </div>
    </div>
</div>